import React, { Component } from "react";
import { klanten } from "../../models/firestore";
import Klant from "./Klant";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import ReactTable from "react-table";
import Cancel from "@material-ui/icons/CancelTwoTone"
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import titleize from "titleize";

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    position: "relative"
  },
  loader: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  header: {
    padding: 16,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #DDD"
  },
  content: {
    flex: 1,
    overflowY: "scroll"
  },
  add: {
    position: "absolute",
    top: 0,
    right: 0,
    height: 20
  }
};
const Klanten = observer(
  class Klanten extends Component {
    constructor(props) {
      super(props);
      this.state = {
        disabled: false,
        displayNaam: "",
        rollen: "",
        currentFilter: "",
        currentFilterPostcode: ""
      };
    }
    componentDidMount() {
      //klanten.query = ref => ref.where('huisnummer', '==', undefined).limit(10);
      // const editable =
      //   this.props.gebruikersrollen.search("admin") > -1 ||
      //   this.props.gebruikersrollen.search("kantoor") > -1;
      // this.setState({
      //   disabled: !editable
      // });
    }

    onPressAdd = async () => {
      try {
        await klanten.add({
          achternaam:
            this.state.currentFilter.length > 2
              ? titleize(this.state.currentFilter)
              : "Nieuw",
          adres: "",
          huisnummer: ""
        });
        this.setState({
          currentFilter:
            this.state.currentFilter.length > 2
              ? this.state.currentFilter
              : "Nieuw"
        });
      } catch (err) {
        alert(err);
      }
    };

    clearFilter = () => {
      this.setState({ currentFilter: "" });
    };

    // onChangeTable(state) {
    //   console.log(state);
    // }

    render() {
      //let gebruikersNaam = "";
      //let gebruikersrollen = "";
      //const { disabled } = this.state;
      let children = undefined;
      const { classes, gebruikersNaam, gebruikersrollen } = this.props;
      const { docs } = klanten;

      //Moet hier nog een promise omheen ????
      //const { isLoading } = klanten;

      children = docs.map(function(klant) {
        return {
          ID: klant.id,
          initialen: klant.data.initialen,
          voornaam: klant.data.voornaam,
          tussenvoegsel: klant.data.tussenvoegsel,
          achternaam: klant.data.achternaam,
          adres: klant.data.adres,
          huisnummer: klant.data.huisnummer || "",
          toevoegsel: klant.data.toevoegsel || "",
          postcode: klant.data.postcode,
          woonplaats: klant.data.woonplaats,
          telefoon: klant.data.telefoon,
          geslacht: klant.data.geslacht,
          klant: klant,
          blokkade: klant.data.opmerking ? klant.data.opmerking.startsWith( 'Blokkade')  ? 'Ja' : '' : 'xx'
        };
      });
      // const ms = (rows, filter, keys) => {
      //   matchSorter(rows, filter, keys);
      // };
      return (
        <div>
          <div align="right" style={{ paddingRight: 20, paddingBottom: 15 }}>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color="primary"
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editklanten") === -1
              }
              onClick={this.clearFilter}
              style={{ marginTop: 10, marginRight: 30 }}
            >
              Toon alles
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color="primary"
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editklanten") === -1
              }
              onClick={this.onPressAdd}
              style={{ marginTop: 10 }}
            >
              Voeg klant toe
            </Button>
          </div>
          <ReactTable
            data={children}
            previousText="Vorige"
            nextText="Volgende"
            loadingText="Laden..."
            noDataText="Geen rijen gevonden"
            pageText="Pagina"
            ofText="van"
            rowsText="rijen"
            filterable
            // filtered={[(id: 'achternaam'), (value: 'Abdi')]}
            filtered={[
              {
                id: "achternaam",
                value: this.state.currentFilter
              }

              // nieuwe situatie op huinummer
              //{
              //  id: "huisnummer",
              //  value: this.state.currentFilter
              //}
              // {
              //   id: 'postcode',
              //   value: this.state.currentFilterPostcode
              // }
            ]}
            //onChange={this.onChangeTable}
            onFilteredChange={(filtered, column) => {
              if (filtered[0]) {
                this.setState({ currentFilter: filtered[0].value });
              } else {
                this.setState({ currentFilter: "" });
              }
              // if (filtered[1]) {
              //   this.setState({ currentFilter: filtered[1].value });
              // }

              // if (column === 'postcode') {
              //   if (filtered[0]) {
              //     this.setState({ currentFilterPostcode: filtered[0].value });
              //   }
              //   if (filtered[1]) {
              //     this.setState({ currentFilterPostcode: filtered[1].value });
              //   }
              // }

              // if (filtered[1]) {
              //   this.setState({ currentFilter: filtered[1].value });
              //   //if filtered[0].value.length === 1
              // } else {
              //   this.setState({ currentFilter: '' });
              // }

              // if (filtered[0]) {
              //   this.setState({ currentFilterPostcode: filtered[0].value });
              //   //if filtered[0].value.length === 1
              // } else {
              //   this.setState({ currentFilterPostcode: '' });
              // }
            }}
            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value
            }
            SubComponent={row => {
              return (
                <Klant
                  key={row.original.ID}
                  klant={row.original.klant}
                  gebruikersNaam={gebruikersNaam}
                  gebruikersrollen={gebruikersrollen}
                />
              );
            }}
            columns={[
              {
                Header: "ID",
                columns: [
                  {
                    Header: "ID",
                    accessor: "ID",
                    width: 50,
                    filterable: false,
                    show: false
                  }
                ]
              },
              {
                Header: "Naam",
                columns: [
                  {
                    Header: "Initialen",
                    accessor: "initialen",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["initialen"] }),
                    filterAll: true
                  },
                  {
                    Header: "Voornaam",
                    accessor: "voornaam",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["voornaam"] }),
                    filterAll: true
                  },
                  {
                    Header: "tussenvoegsel",
                    accessor: "tussenvoegsel",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["tussenvoegsel"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Achternaam",
                    accessor: "achternaam",
                    width: 150,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["achternaam"] }),
                    //filterMethod: (filter, rows) => ms(rows, filter.value, { keys: ['achternaam'] }),
                    filterAll: true,
                    //style: {backgroundColor: "yellow"}}
                  }
                ]
              },
              {
                Header: "Adres",
                columns: [
                  {
                    Header: "Straat",
                    accessor: "adres",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["adres"] }),
                    filterAll: true
                  },
                  {
                    Header: "Huisnummer",
                    accessor: "huisnummer",
                    width: 50,
                    filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['huisnummer'] ,threshold: matchSorter.rankings.EQUAL}),
                    filterAll: true
                  },
                  {
                    Header: "Toevoegsel",
                    accessor: "toevoegsel",
                    width: 50
                    //filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['toevoegsel'] }),
                    //filterAll: true
                  },
                  {
                    Header: "Postcode",
                    accessor: "postcode",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["postcode"] }),
                    filterAll: true
                  },
                  {
                    Header: "Woonplaats",
                    accessor: "woonplaats",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["woonplaats"] }),
                    filterAll: true
                  }
                ]
              },
              {
                Header: "Diversen",
                columns: [
                  {
                    Header: "Telefoon",
                    accessor: "telefoon",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["telefoon"] }),
                    filterAll: true
                  },
                  {
                    Header: "Geslacht",
                    accessor: "geslacht",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["geslacht"] }),
                    filterAll: true
                  },
                  {
                    Header: "XX",
                    accessor: "blokkade",
                    Cell: row => (
                      <span>
                        {row.value === "Ja" ? (
                          <Cancel style={{ color: "red" }} />
                        ) : null}
                      </span>
                    ),
                    width: 50,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["blokkade"] }),
                    filterAll: true
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: "achternaam",
                desc: false
              }
            ]}
            defaultPageSize={20}
            className="-striped -hightlight"
          />
          <Paper
            style={{ marginLeft: "200px", marginRight: "200px", marginTop: 30 }}
          >
            U bent ingelogd als {gebruikersNaam} en heeft de rollen{" "}
            {gebruikersrollen}
          </Paper>
        </div>
      );
    }
  }
);

export default withStyles(styles)(Klanten);



// WEBPACK FOOTER //
// ./src/components/Klanten/Klanten.jsx